import { ActionTypes } from "../constants";
import { combineReducers } from "redux";
import { addOrReplace } from "../utilities/reducers";

const reduceResources = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_RESOURCES_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_RESOURCES_FAILURE:
            return [];

        case ActionTypes.GET_RESOURCE_DETAILS_SUCCESS:
            return addOrReplace(state, action.data);

        case ActionTypes.DELETE_RESOURCE_SUCCESS:
            const resourceId = Number(action.payload.id);
            return state.filter(({ id }) => Number(id) !== resourceId);

        case ActionTypes.LOGOUT:
            return [];

        default:
            return state;
    }
};

const reduceUploadResource = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.ADD_RESOURCE_SUCCESS:
            return Number(action.data.id);

        case ActionTypes.UPDATE_RESOURCE_SUCCESS:
            return Number(action.payload.id);

        case ActionTypes.GET_RESOURCES_SUCCESS:
            return false;

        case ActionTypes.GET_RESOURCE_DETAILS_SUCCESS:
            if (!state) return state;
            return Number(action.data.id) !== state && state;

        default:
            return state;
    }
};

const resources = combineReducers({
    resources: reduceResources,
    uploading: reduceUploadResource,
});

export default resources;
export const getResources = ({ resources }) => resources;
export const getResource = ({ resources }, resourceId) =>
    !resources ? null : resources.find(({ id }) => Number(id) === resourceId);
export const getUploadedResourceId = ({ uploading }) => uploading;
